
export enum AmplifyErrorStrings {
  AUTH_ERROR_STRING = 'The user is not authenticated'
}

export enum AppErrorCode {
  AUTH_ERROR = 'AUTH_ERROR', // User authentication failed while exchanging code for JWT
  AUTH_REFRESH_FAILED = 'AUTH_REFRESH_FAILED', //Token Refresh Failed
  AUTH_COGNITO_ERROR = 'AUTH_COGNITO_ERROR', //App received error from Cognito as a URL query parameter
  UNKNOWN_ERROR = 'UNKNOWN_ERROR', //Something unexpected went wrong
  API_ERROR = 'API_ERROR',
}

export enum AppErrorState {
  AUTH_ERROR = 'AUTH_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export const defaultAppErrorState = AppErrorState.AUTH_ERROR;

export enum BackEndErrorState {
  FIELDS_VALIDATION_FAILED = 'FIELDS_VALIDATION_FAILED',
  USER_ALREADY_REGISTERED = 'USER_ALREADY_REGISTERED',
  GENERIC_AUTH_ERROR = 'GENERIC_AUTH_ERROR',
}

export const backendErrorReverseDict: Record<string, BackEndErrorState> = {
  ['01.01-01.01']: BackEndErrorState.FIELDS_VALIDATION_FAILED,
  ['01.01-01.04']: BackEndErrorState.FIELDS_VALIDATION_FAILED,
  ['01.01-01.05']: BackEndErrorState.USER_ALREADY_REGISTERED,
};

export const defaultBackendErrorState = BackEndErrorState.GENERIC_AUTH_ERROR;

export const publicErrorCodesDict: Record<string, string> = {
  [AppErrorCode.AUTH_ERROR]: '01.02-01.01',
  [AppErrorCode.AUTH_REFRESH_FAILED]: '01.02-01.03',
  [AppErrorCode.AUTH_COGNITO_ERROR]: '01.02-01.04',
  [AppErrorCode.UNKNOWN_ERROR]: '01.02-01.05',
  [AppErrorCode.API_ERROR]: '01.02-01.06',
};

export const appErrorCodeToErrorStateDict: Record<string, AppErrorState> = {
  [AppErrorCode.AUTH_ERROR]: AppErrorState.AUTH_ERROR,
  [AppErrorCode.AUTH_REFRESH_FAILED]: AppErrorState.AUTH_ERROR,
  [AppErrorCode.UNKNOWN_ERROR]: AppErrorState.AUTH_ERROR,
  [AppErrorCode.AUTH_COGNITO_ERROR]: AppErrorState.AUTH_ERROR,
};

export const supportEmailHrefProto =
  'mailto:support@meetami.ca?subject=AmiLearn Support Request - user has encountered error {{publicErrorCode}}&body=Error on {{referrerURL}}%0D%0AUser Agent %26 OS Information:: {{userAgent}}%0D%0A%0D%0ATo help us assist you better, please provide a brief description below of the action you performed when the error occurred.';

export const publicRrrorCodeTemplateVar = '{{publicErrorCode}}';
export const referrerURLTemplateVar = '{{referrerURL}}';
export const userAgentTemplateVar = '{{userAgent}}';
